import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { translations } from './translations'

export const defaultNS = 'common'
export const resources = {
  es: {
    common: translations.es,
  },
  en: {
    common: translations.en,
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    ns: ['common'],
    defaultNS,
    resources,
    // Translation keys are flat dotted strings (e.g. 'dashboard.todays_agenda'),
    // not nested objects — disable key/namespace splitting so they resolve from
    // the resource bundles instead of falling back to inline defaults.
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // No explicit `lng` so the user's saved choice (localStorage) wins on reload;
    // with nothing saved it falls back to Spanish. 'navigator' is intentionally
    // omitted so the default stays Spanish regardless of browser language.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
  })

export default i18n
